<div class="close-btn-wrapper mat-dialog-actions end-align">
  <button mat-button (click)="closeDialog()" class="cross-btn">
    <img src="assets/images/cross-img.png" alt="close" />
  </button>
</div>

<div class="message-wrapper">
  <div class="spell-main-wrapper">
    <div class="spell-header">
      <h2>{{inboxData?.premium_games_title}}</h2>
      <!-- <p>Pay less <span>Points</span> as a <span>Syndicate Member</span></p> -->
       <p>{{inboxData?.description}}</p>
    </div>

    <div class="spell-wrapper">
      <!-- Row 1 -->
    @for (promo of inboxData?.promo_details; track $index) {
      <div 
        class="spell-row" 
        [ngClass]="[getLogoClass($index), promo.status ? 'disabled' : '']">

        <!-- Left Text -->
        <div class="spell-text">
          <p class="spell-title">{{ promo.title }}</p>
          @if (promo.promo_offer) {
            <p class="spell-subtitle">
              @if (promo.promo_icon) {
                <img [src]="promo.promo_icon" [alt]="promo.title + ' icon'" />
              }
              {{ promo.promo_offer }}
            </p>
          }
        </div>

        <!-- Right Icon -->
        <div class="spell-status" (click)="getCurrentPromoDetails(promo)">
          @if (promo.status) {
            <img src="assets/icon/spell-of-fortune/tick.png" alt="tick icon" />
          } @else {
            <img src="assets/icon/spell-of-fortune/right-arrow.png" alt="arrow icon" />
          }
        </div>

      </div>
    }


     <!--  <div class="spell-row logo-st disabled">
        <div class="spell-text">
          <p class="spell-title">Join a syndicate</p>
          <p class="spell-subtitle">
            <img src="assets/icon/spell-of-fortune/jewel-small.png" alt="jewel icon" />
            Points
          </p>
        </div>
        <div class="spell-status">
          <img src="assets/icon/spell-of-fortune/tick.png" alt="tick icon" />
        </div>
      </div> -->

      <!-- Row 2 -->
      <!-- <div class="spell-row logo-nd">
        <div class="spell-text">
          <p class="spell-title">Activate Auto Top-Up</p>
          <p class="spell-subtitle"></p>
        </div>
        <div class="spell-status">
          <img src="assets/icon/spell-of-fortune/right-arrow.png" alt="arrow icon" />
        </div>
      </div>
 -->
      <!-- Row 3 -->
     <!--  <div class="spell-row logo-rd disabled">
        <div class="spell-text">
          <p class="spell-title">Activate Jackpot Trigger</p>
          <p class="spell-subtitle">
            <img src="assets/icon/spell-of-fortune/jewel-small.png" alt="jewel icon" />
            Points & Lottery Lines
          </p>
        </div>
        <div class="spell-status">
          <img src="assets/icon/spell-of-fortune/tick.png" alt="tick icon" />
        </div>
      </div> -->

      <!-- Row 4 -->
      <!-- <div class="spell-row logo-th disabled">
        <div class="spell-text">
          <p class="spell-title">Refer a Friend</p>
          <p class="spell-subtitle">
            <img src="assets/icon/spell-of-fortune/jewel-small.png" alt="jewel icon" />
            Points
          </p>
        </div>
        <div class="spell-status">
          <img src="assets/icon/spell-of-fortune/tick.png" alt="tick icon" />
        </div>
      </div> -->
    </div>
  </div>
</div>
